
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.OffPlanned = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.offplanned.maxdeviation'),
                  attributes: {
                    'class': 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'off_planned_maxDeviationMinutes',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    'type': 'text',
                    name: 'off_planned_maxDeviationMinutes',
                    'maxlength': '10',
                    'alt': '',
                    value: '',
                    size: '11',
                    'id': 'off_planned_maxDeviationMinutes',
                    'class': 'modelAttribute textField numberPicker mandatory',
                    'autocomplete': 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    const selector = '#off_planned_maxDeviationMinutes';

    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      $(selector).val(
        jsonParam.maxDeviationMinutes
      );
    }
  },
  retrieveParameter() {
    let selector = '#off_planned_maxDeviationMinutes',
      _maxDeviation;

    _maxDeviation = $(selector).val();
    _maxDeviation = parseInt(_maxDeviation, 10);


    return JSON.stringify({
      maxDeviationMinutes: _maxDeviation,
    });
  },
};
